<template>
    <div id="checkout-component">

        <h1></h1>
        <div class="wrapper">
            <div class="content">
                <div class="header">
                    <img src="https://sistema.redmedical.mx/images/logo-red-medical.svg"
                         style="width: 250px; height: auto; display: block; margin: 0 auto;"
                         class="logo"
                         alt="Redmedical Logo">
                </div>

                <div class="body">
                    <div class="emoji" style="color: #dadce0; font: 200px/1.25 Open Sans,sans-serif;">(;-;)</div>
                    <h1>¡Hola!</h1>
                    <p>{{ mensaje }}</p>
                </div>

                <div class="footer">
                    <p>Si tienes alguna duda comunicate con nosotros: <a href="#">https://redmedical.mx</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "checkout",
    props: {
        mensaje: {
            type: String,
            required: true
        },
    },
}
</script>
<style scoped>
body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    background-color: #f8fafc;
    color: #3d4852;
    height: 100vh;
    line-height: 1.4;
    margin: 0;
    padding: 0;
    width: 100% !important;
}

.wrapper {
    box-sizing: border-box;
    padding: 35px;
}

.content {
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 3px;
    box-shadow: 0 2px 0 rgba(0, 0, 150, 0.025), 2px 4px 0 rgba(0, 0, 150, 0.015);
    margin: 0 auto;
    max-width: 570px;
    padding: 35px;
}

.header {
    padding-bottom: 25px;
    text-align: center;
}

.body {
    border-bottom: 1px solid #edeff2;
    border-top: 1px solid #edeff2;
    padding-top: 25px;
    padding-bottom: 25px;
}

.footer {
    box-sizing: border-box;
    padding-top: 25px;
    text-align: center;
}

h1 {
    color: #2d3748;
    font-size: 19px;
    font-weight: bold;
    margin-top: 0;
    text-align: left;
}

p {
    font-size: 16px;
    line-height: 1.5em;
    margin-top: 0;
    text-align: left;
}

</style>

